import { SCHEDULE_FORM_WEEKDAY_KEYS } from "@/schemas/scheduleFormWeekdays";
import { DateTime } from "luxon";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useWeekdays = () => {
  const { i18n } = useTranslation();

  const weekdays = useMemo(() => {
    const now = DateTime.now();
    const monday = now.minus({ days: now.weekday - 1 }).startOf("day");
    const labelFormatter = new Intl.DateTimeFormat(i18n.language, {
      weekday: "short",
    });

    return Array.from({ length: 7 }, (_, i) => {
      const day = monday.plus({ days: i });
      const idx = day.weekday - 1;
      return {
        label: labelFormatter.format(day.toJSDate()),
        value: SCHEDULE_FORM_WEEKDAY_KEYS[idx],
      };
    });
  }, [i18n.language]);

  return weekdays;
};
